import Hashids from 'hashids'
const hashKey = "V9J8a1XgEbYfFi9XrsuCBkGvRPk6";
var crypto = require('crypto')
const ivText = process.env.REACT_APP_IVTEXT;
const key = process.env.REACT_APP_KEY;
const cipherAlgo = "AES-128-CBC";

var algorithm = 'SHA1';
var textkey = "P@rkEZ241du19"
    , salt = "P@rkEZ4s3123"
    , shasum2 = crypto.createHash(algorithm);

shasum2.update(textkey);

var binaryIV = new Buffer(ivText, "hex");
var binaryEncryptionKey = new Buffer(key, "hex");

export const decrypt = function (text){
    var decipher = crypto.createDecipheriv(cipherAlgo, binaryEncryptionKey, binaryIV);
    var a = decipher.update(text, "base64", "binary");
    var b = decipher.final("binary");
    var decryptedInput = a + b;//Buffer.concat([a,b]);
    //console.log(decryptedInput.toString());

    return decryptedInput.toString();
}

export const encrypt = function (text){
    var cipher = crypto.createCipheriv(cipherAlgo, binaryEncryptionKey, binaryIV);
    var string = cipher.update(text, 'utf8', 'base64');
    string += cipher.final('base64');

    return string;
}

export const encode = function(text){
    var hashids = new Hashids(hashKey);
    var encode = hashids.encode(text);
    return encode; 
}

export const decode = function(text){
    var hashids = new Hashids(hashKey);
    var decode = hashids.decode(text); 
    return decode; 
}
